import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { PhotoEditorToolsTextService } from '../photo-editor-tools/photo-editor-tools-text/photo-editor-tools-text.service';

@Injectable({
  providedIn: 'root'
})
export class PhotoEditorCanvasService {

  private listenerSelectedTool = new Subject<any>();
  private listenerSelectFontColor = new Subject<any>();
  private listenerSelectFont = new Subject<any>();
  private listenerShowSelectFontColor = new Subject<any>();
  private listenerSelectedElement = new Subject<any>();
  private listenerDeleteElement = new Subject<any>();
  private listenerMoveLeftElement = new Subject<any>();
  private listenerMoveRightElement = new Subject<any>();
  private listenerMoveUpElement = new Subject<any>();
  private listenerMoveDownElement = new Subject<any>();
  private listenerAddItem = new Subject<any>();


  constructor(private photoEditorToolsTextService: PhotoEditorToolsTextService) { }

  public listenSelectedTool() {
    return this.listenerSelectedTool.asObservable();
  }

  public selectTool(tool) {
    this.listenerSelectedTool.next(tool);
  }

  public listenSelectFontColor() {
    return this.listenerSelectFontColor.asObservable();
  }

  public selectFontColor(fontColor) {
    this.listenerSelectFontColor.next(fontColor);
  }

  public listenShowSelectFontColor() {
    return this.listenerShowSelectFontColor.asObservable();
  }

  public showSelectFontColor(show) {
    this.listenerShowSelectFontColor.next(show);
  }

  public listenSelectedElement() {
    return this.listenerSelectedElement.asObservable();
  }

  public selectElement(element) {
    this.listenerSelectedElement.next(element);
  }

  public listenDeleteItem() {
    return this.listenerDeleteElement.asObservable();
  }

  public deleteElement() {
    this.listenerDeleteElement.next();
  }

  public listenMoveLeftElement() {
    return this.listenerMoveLeftElement.asObservable();
  }

  public moveLeftElement() {
    this.listenerMoveLeftElement.next();
  }

  public listenMoveRightElement() {
    return this.listenerMoveRightElement.asObservable();
  }

  public moveRightElement() {
    this.listenerMoveRightElement.next();
  }

  public listenMoveUpElement() {
    return this.listenerMoveUpElement.asObservable();
  }

  public moveUpElement() {
    this.listenerMoveUpElement.next();
  }

  public listenMoveDownElement() {
    return this.listenerMoveDownElement.asObservable();
  }

  public moveDownElement() {
    this.listenerMoveDownElement.next();
  }

  public listenAddItem() {
    return this.listenerAddItem.asObservable();
  }

  public addItem(el) {
    this.listenerAddItem.next(el);
  }

  public click(currentTool, el, e, opts) {
    switch (currentTool.id) {
      case 'text':
        this.addItem(this.photoEditorToolsTextService.createText(el, e.offsetX, e.offsetY, opts));
    }
  }
}
